module.exports = __webpack_public_path__ + "img/2_01.d105241c.jpg";